import { Directive, ViewContainerRef } from '@angular/core';
import { DialogContainerService } from './dialog-container.service';
/**
 * Provides an insertion point for the Dialogs that are created through the Dialog service.
 *
 * @example
 * ```html-no-run
 * <div kendoDialogContainer></div>
 * ```
 *
 * Created Dialogs will be mounted after this element.
 *
 * For an example on sample usage, refer to the
 * [`DialogService.open`]({% slug api_dialog_dialogservice %}#toc-open) method.
 *
 */
var DialogContainerDirective = /** @class */ (function () {
    function DialogContainerDirective(container, service) {
        service.container = container;
    }
    DialogContainerDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[kendoDialogContainer]'
                },] },
    ];
    /** @nocollapse */
    DialogContainerDirective.ctorParameters = function () { return [
        { type: ViewContainerRef, },
        { type: DialogContainerService, },
    ]; };
    return DialogContainerDirective;
}());
export { DialogContainerDirective };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dialog/dist/es/dialog/dialog-container.directive.js
// module id = ../../../../@progress/kendo-angular-dialog/dist/es/dialog/dialog-container.directive.js
// module chunks = vendor